import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className = ''
}: Props) {
  const reduced = useReducedMotion();
  if (reduced) {
    return <div className={className} data-id="element-226" data-mp="3ggpga0q6j87c">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-227" data-mp="3gfxmmvg57kjp">
      {children}
    </motion.div>;
}